import { Link, useLocation } from 'react-router-dom';
import './ServicePage.css';

// Sidebar items — same routes as the current build
const DEFAULT_ITEMS = [
  { label: 'Ocean Freight',              url: '/Global',        icon: 'ship' },
  { label: 'Air Freight',                url: '/AirChartering', icon: 'plane' },
  { label: 'Warehousing & Distribution', url: '/Logistics',     icon: 'warehouse' },
  { label: 'Custom Clearance',           url: '/Customs',       icon: 'document' },
  { label: 'Contract Logistics',         url: '/Cargo',         icon: 'contract' },
  { label: 'Crane Rentals',              url: '/Vessel',        icon: 'crane' },
];

const ICONS = {
  ship: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 20h20" />
      <path d="M4 16l-1-6h18l-1 6" />
      <path d="M6 10V4h12v6" />
      <path d="M10 4v6M14 4v6" />
    </svg>
  ),
  plane: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
    </svg>
  ),
  warehouse: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21V9l9-6 9 6v12" />
      <path d="M9 21v-6h6v6" />
    </svg>
  ),
  document: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="9" y1="17" x2="15" y2="17" />
    </svg>
  ),
  contract: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12" />
    </svg>
  ),
  crane: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 22V4l18 8" />
      <path d="M4 4h10" />
      <line x1="22" y1="12" x2="22" y2="18" />
      <rect x="19" y="18" width="6" height="4" rx="1" />
    </svg>
  ),
};

export default function AnimatedList({ items = DEFAULT_ITEMS }) {
  const { pathname } = useLocation();

  return (
    <aside className="service-sidebar">
      <p className="service-sidebar__title">Our Services</p>

      <nav className="service-sidebar__list">
        {items.map(item => {
          const isActive = pathname === item.url;
          return (
            <Link
              key={item.url}
              to={item.url}
              className={`service-sidebar__item ${isActive ? 'is-active' : ''}`}
            >
              <span className="service-sidebar__icon">
                {ICONS[item.icon] || ICONS.ship}
              </span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="service-sidebar__cta">
        <h4>Need a Quote?</h4>
        <p>Get a custom freight quote in 24 hours.</p>
        <Link to="/Contact">Contact Us</Link>
      </div>
    </aside>
  );
}